import { App } from "../../app/App";
import { WebAppProject } from "../project/WebAppProject";
import { WebApp } from "../WebApp";
import { WebAppComponent } from "../WebAppComponent";
import { AppCommand } from "./AppCommand";
import { AppCommandContext } from "./AppCommandContext";
import { AppConditionVariable } from "./AppConditionVariable";

export class AppCommandsManager<C,P extends WebAppProject> extends WebAppComponent<C,P>
{
  protected _conditions:AppConditionVariable[] = [];
  protected _conditionsMap:Map<string,AppConditionVariable> = new Map<string,AppConditionVariable>();
  protected _commands:AppCommand[] = [];  


  static _createContext( command:AppCommand )
  {    
    return command.manager._createContextFor( command );   
  }

  private _createContextFor( command:AppCommand ):AppCommandContext<any,any>
  {
    return new AppCommandContext<any,any>( this.webApp );    
  }

  static _addCommands( manager:AppCommandsManager<any,any>, commands:AppCommand[] )
  {
    commands.forEach( 
      c =>
      {
        manager._commands.push( c ); 
        AppCommand._addToCommandManager( c, manager ); 
      }
    );
  }
}